<div *ngIf="videoAvaliable">
<div class=" border">
    <div class="padding-10" fxLayout="row">
      <b class="f20">Videos
      </b>
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="row"style="width: 100%;">
      <div class="padding-10"  style="width: 100%;">
        <iframe style="width: 100%;" height="333" [src]="youtubeUrl+videourl | safe: 'resourceUrl'"></iframe>
      </div>
    </div>
  </div>
  </div>